(function () {
  'use strict';

  /**
   * SC Scroll Reveal — The Self Care Club
   * Adds .sc-reveal + stagger classes to homepage elements.
   * IntersectionObserver fires .is-visible when they enter viewport.
   * No external libraries. Hardware-accelerated (opacity + transform only).
   */

  // Child selectors that receive individual stagger (items within a section)
  var STAGGER_TARGETS = [
    '.sc-proof-item',   // Social proof stats (4)
    '.sc-trust-item',   // Trust badge items (5)
    '.sc-hiw-step',     // How It Works steps (3)
    '.sc-press-name'    // As Seen In publication names
  ];

  // Section schema classes that already use child stagger — skip section-level fade
  var CHILD_STAGGER_SECTIONS = [
    'sc-social-proof',
    'sc-trust-badges',
    'sc-how-it-works',
    'sc-as-seen-in'
  ];

  // Never animate — these are above the fold on load
  var ABOVE_FOLD_SECTIONS = [
    'sc-announcement-bar',
    'scc-hero-wrapper'
  ];

  function initAnimations() {
    // Bail out if user prefers reduced motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Bail if IntersectionObserver isn't available (very old browsers)
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target); // fire once
          }
        });
      },
      {
        threshold: 0.08,
        rootMargin: '0px 0px -32px 0px'
      }
    );

    // 1. Stagger child items within key sections
    STAGGER_TARGETS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (el, i) {
        el.classList.add('sc-reveal', 'sc-reveal--d' + Math.min(i + 1, 5));
        observer.observe(el);
      });
    });

    // 2. Section-level fade for remaining sections (bundles, comparison, products, etc.)
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      var isAboveFold = ABOVE_FOLD_SECTIONS.some(function (cls) {
        return section.classList.contains(cls);
      });
      var hasChildStagger = CHILD_STAGGER_SECTIONS.some(function (cls) {
        return section.classList.contains(cls);
      });
      if (!isAboveFold && !hasChildStagger) {
        section.classList.add('sc-reveal');
        observer.observe(section);
      }
    });
  }

  // Run after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimations);
  } else {
    initAnimations();
  }
})();
